import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {MaintenanceService} from './maintenance.service';
import {NoteService} from './note/note.service';

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    SharedModule
  ],
  providers: [
    MaintenanceService,
    NoteService
  ]
})
export class MaintenanceModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/maintenance/maintenance.module.ts